// --- src/utils/sounds.js ---

export const playSound = (type) => {
  let audioUrl = "";

  switch (type) {
    // --- 1. SONIDOS EXISTENTES (.wav) ---
    case 'pass': 
    case 'win': 
      audioUrl = "/sounds/pass.wav"; 
      break;
      
    case 'streak': 
      audioUrl = "/sounds/racha.wav"; 
      break;
      
    case 'gameover': 
      audioUrl = "/sounds/gameover.wav"; 
      break;

    // --- 2. SONIDOS NUEVOS (.mp3) ---
    case 'compra':
      audioUrl = "/sounds/compra.mp3";
      break;

    case 'start':
      audioUrl = "/sounds/start.mp3";
      break;
    case 'book':
      audioUrl = "/sounds/bookopening.mp3";
      break;

    // ✅ NUEVO: Ahora 'wow' ya tiene su ruta asignada
    case 'wow':
      audioUrl = "/sounds/wow.mp3";
      break;

       case 'modulo1':
      audioUrl = "/sounds/modulo1.mp3";
      break;

        case 'vocabcompra':
      audioUrl = "/sounds/vocabcompra.mp3";
      break;
      
      case 'selection': 
      audioUrl = "/sounds/selection.mp3"; 
      break;

    // 🔇 CASO GENÉRICO: 'wrong' no hace nada (sin sonido por ahora)
    case 'wrong':
      return; 

    default:
      console.warn(`Sonido no encontrado: ${type}`);
      return;
  }

  // Solo intentamos reproducir si hay una URL definida
  if (audioUrl) {
    const audio = new Audio(audioUrl);
    audio.volume = 0.5; 
    audio.play().catch(e => console.log("Error reproduciendo audio:", e));
  }
};